<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-form v-bind="this.$attrs" ref="form">
            <div class="d-flex">
              Xin vui lòng điền tiền tố:
              <v-text-field
                class="mx-2"
                v-model="prefix"
                label="Tiền tố"
                :rules="[rules.required, rules.prefixLength]"
                dense
                outlined
              ></v-text-field>
            </div>
            <span>
              <span style="color: red"
                ><i><strong>(*) Lưu ý:</strong></i></span
              >
              Tiền tố phải có đủ 3 ký tự.
            </span>
            <p class="ma-0">
              Thao tác này sẽ đánh số báo danh tất cả các học sinh lại từ đầu.<br />
              Bạn có chắc là bạn muốn thực hiện thao tác không?
            </p>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="progressDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Đang xử lý</v-card-title>
        <v-card-text>
          <v-progress-linear :value="progress" color="blue darken-4" stream></v-progress-linear>
          <div class="progress-text">{{ formattedProgress }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StudentExam } from '../../plugins/api'
import { mapActions } from 'vuex'
export default {
  props: {
    exam: String,
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      } else {
        this.updateProgress()
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      progressDialog: false,
      alertShown: false,
      progress: 0,
      formattedProgress: '',
      prefix: '',
      rules: {
        required: value => !!value || 'Phải nhập tiền tố',
        prefixLength: value => value.length === 3 || 'Tiền tố phải có đủ 3 ký tự.'
      }
    }
  },
  methods: {
    ...mapActions('indexing', ['fetchIndexings', 'updateIndexing']),
    cancel() {
      this.$emit('closeDialog')
    },
    async confirm() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const indexing = await StudentExam.indexingStudent({ exam: this.exam, prefix: this.prefix })

        if (indexing) {
          await this.getProgress()
        } else {
          this.$alert.error('Lỗi đánh số báo danh')
          this.cancel()
        }
        this.$loading.active = false
      }
    },
    async getProgress() {
      this.progressDialog = true
      this.updateProgress()
      this.progressInterval = setInterval(() => {
        this.updateProgress()
      }, 5000)
    },

    async updateProgress() {
      const progressData = await this.fetchIndexings({ exam: this.exam })
      const { progress, studentCount, totalStudent, status } = progressData[0]

      this.progress = progress
      console.log(this.progress)
      if (status === 'available') {
        this.progress = 0
        this.alertShown = false
      } else if (status === 'indexing') {
        this.progressDialog = true
        if (!this.alertShown) {
          this.$alert.warn('Xin vui lòng đợi để thao tác cũ thực hiện xong')
          this.alertShown = true
        }
        this.formattedProgress = `Đang xử lý ${studentCount}/${totalStudent} học sinh`
      } else if (status === 'finish') {
        this.$loading.active = true
        await this.updateIndexing({ id: progressData[0].id, status: 'available' })
        this.formattedProgress = ''

        clearInterval(this.progressInterval)
        this.progressDialog = false
        this.$alert.success('Thao tác đánh số trước đã thành công!')
        this.$emit('refresh')
        this.cancel()
      }
    }
  },

  destroyed() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval)
    }
  }
}
</script>
<style scoped>
.progress-text {
  text-align: center;
  margin-top: 10px;
  font-family: 'Roboto';
}
</style>
